<template>
  <div>
    <!-- Form -->
    <v-container grid-list-md>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }}</span>
          </v-card-title>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-select
                      label="Report Master"
                      item-text="report_title"
                      item-value="id"
                      v-model="formSchema.report_id"
                      :items="ReportName"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-select
                      label="Report Parameter"
                      item-text="parameter_title"
                      item-value="id"
                      v-model="formSchema.parameter_id"
                      :items="ParameterName"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-text-field
                      label="Serial Number"
                      v-model="formSchema.serial_num"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Parameter Title"
                      v-model="formSchema.parameter_title"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 sm3>
                    <v-checkbox
                      v-model="formSchema.is_active"
                      label="Active"
                      :value="isActiveVal"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="pr-4">
                    <v-container fluid>
                      <v-radio-group v-model="formSchema.is_mandatory" row>
                        <v-radio label="Required" :value="1"></v-radio>
                        <v-radio label="Not Required" :value="0"></v-radio>
                      </v-radio-group>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="info" flat @click.native="close(0)">
                <v-icon>refresh</v-icon>Reset
              </v-btn>
              <v-btn
                class="success"
                flat
                v-if="userRole.saveButton || userRole.updateButton"
                @click.native="validateBeforeSubmit"
              >
                <v-icon>save</v-icon>
                {{ buttonTitle }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-container>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");

export default {
  props: ["formSchema"],

  data: () => ({
    valid: true,
    isActiveVal: 1,
    roleList: [],
    ParameterName: [],
    ReportName: []
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Report Details"
        : "Add Report Details";
    },
    buttonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },

    // User Previlization methods
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  created() {
    let root = this;
    // Asset Location List
    commonService.getAllData("get_menu_info").then(res => {
      root.MainMenus = res.data;
    });
    // Asset Location List
    commonService.getAllData("get_report_masters_info").then(res => {
      root.ReportName = res.data;
    });
    // Asset Location List
    commonService.getAllData("get_report_parameter_masters_info").then(res => {
      root.ParameterName = res.data;
    });
  },

  methods: {
    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;
      console.log(formSchema);

      var root = this;
      if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "report_details")
            .then(res => {
              this.close(res);
            });
        } else {
          commonService
            .insertFormData(this.formSchema, "report_details")
            .then(res => {
              this.close(res);
            });
        }
      }
    },

    close: function(data) {
      if (data.status == 1) {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitCloseModal", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/report/report_details/report_details_form.vue